import {DOCUMENT} from '@angular/common';
import {Inject, Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DOMService {

  constructor(@Inject(DOCUMENT) private document: Document) {
  }

  public getBody(): HTMLElement {
    return this.document.body;
  }

  public getElementsByClassname(className: string): HTMLCollection {
    return this.document.getElementsByClassName(className);
  }
}
